export default {
    OPT_IN: 1,
    OPT_OUT: 2,
    OPT_INVITED: 3,
    OPT_CLOSED: 4
};
